import { PayloadAction, createSlice } from "@reduxjs/toolkit";
import { onGetVideos } from "./AdminThunk";
import InfoVideo from "../../domain/entities/InfoVideo";

interface AdminState {
	isLoading: boolean;
	idVideos: InfoVideo[];
	error?: string;
}

const initialState: AdminState = {
	isLoading: false,
	idVideos: [],
	error: undefined,
};

const adminSlice = createSlice({
	name: "admin",
	initialState,
	reducers: { },
	extraReducers: (builder) => {
		builder
			.addCase(onGetVideos.pending, (state) => {
				state.isLoading = true;
			})
			.addCase(
				onGetVideos.fulfilled,
				(state, action: PayloadAction<InfoVideo[]>) => {
					state.isLoading = false;
					state.idVideos = action.payload;
				}
			)
			.addCase(onGetVideos.rejected, (state, action) => {
				state.error = action.error.message;
				state.isLoading = false;
			});
	},
});
export default adminSlice.reducer;